import state from './module-email-receive-alert-state';
import mutations from './module-email-receive-alert-mutations';
import actions from './module-email-receive-alert-actions';
import getters from './module-email-receive-alert-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
